<template>
  <el-card
    header="Special Services"
    shadow="never"
  >
    <el-col :span="24">
      <p>
        <b>Tailgate</b><br>
        {{ getFeatures('tailgate') ? 'Yes' : 'No' }}
      </p>

      <p>
        <b>Timeslot</b><br>
        {{ getFeatures('timeslot') }}
      </p>
      <p>
        <b>Saturday Delivery</b><br>
        {{ getFeatures('saturday_delivery') ? 'Yes' : 'No' }}
      </p>
      <p>
        <b>Moffett</b><br>
        {{ getFeatures('moffett') ? 'Yes' : 'No' }}
      </p>
      <p>
        <b>Hand Unload</b><br>
        {{ getFeatures('handunload') ? 'Yes' : 'No' }}
      </p>
      <p>
        <b>Two Man Lift</b><br>
        {{ getFeatures('twomanlift') ? 'Yes' : 'No' }}
      </p>
    </el-col>
  </el-card>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFeatures (key) {
      if (this.consignment.features && this.consignment.features.features && this.consignment.features.features.length > 0) {
        const feature = this.consignment.features.features[0][key]
        if (feature !== undefined && feature !== null) {
          // For objects like timeslot, stringify or format as needed
          if (typeof feature === 'object') {
            // Format timeslot as "Ready: [ready], Closing: [closing]"
            return `Ready: ${feature.ready}, Closing: ${feature.closing}`
          }
          return feature
        }
      }
      return false
    }
  }
}
</script>
